
import request from '@/axios'

export function fetchEnrollmentAvailability (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/get_maximum_availability/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function chooseSlotToBook (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/getAvailableTimeSlots/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
  
}

export function bookenrollmentSlots (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/getAvailableTimeSlots/calculated/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function choosenSlot (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/generate/demoSchedule/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}
export function fetchConfirmDetails (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/confirmation/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function finalEnroll (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}

export function getFixedSchedules (customer_id, course_id, payload) {
  return request({
    url: `V1/course/enrollment/getCourseFixedSchedules/${customer_id}/${course_id}`,
    method: 'POST',
    data: payload
  })
}